<template>
  <common-card>
    <v-toolbar color="primary" dense dark flat>
      <v-toolbar-title>
        <span class="font-montserrat font-weight-bold">Reporte Emisiones Alianzas</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col md="3">
          <v-select
            label="Seleccionar Alianza"
            :items="alianzas"
            item-text="nombre"
            item-value="id"
            v-model="alianza"
            outlined
            class="mt-5"
          />

          <v-radio-group v-model="modo" row>
            <v-radio label="Rango de fechas" value="rango" />
            <v-radio label="General" value="general" />
          </v-radio-group>

          <!-- Restricción de los últimos dos meses deshabilitada temporalmente. -->
          <v-date-picker
            v-if="modo === 'rango'"
            v-model="dates"
            range
            locale="es"
          />

          <v-btn
            block
            color="primary"
            dark
            :disabled="!puedeEjecutar"
            class="mt-4"
            @click="consultar"
          >
            Ejecutar Reporte
          </v-btn>

          <v-btn
            block
            class="mt-3"
            color="success"
            :disabled="reportDownload.length === 0 || rol === 'WORKFORCE'"
            v-if="(rol !== 'WORKFORCE')"
            @click="descargarCSV(false)"
          >
            Descargar
          </v-btn>
          
          <v-btn
            block
            class="mt-3"
            color="success"
            :disabled="(reportDownload.length === 0 || rol !== 'WORKFORCE')"
            v-if="(rol === 'WORKFORCE')"
            @click="descargarCSV(true)"
          >
            Descargar reporte
          </v-btn>
        </v-col>

        <v-col md="9">
          <v-data-table
            :headers="columns"
            :items="polizas"
            class="elevation-1"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { mainAxios } from "@/mainAxios";
import { getAlianzas } from "@/services/alianzas/alianzas.service.js";
import moment from "moment";

export default {
  components: {
    CommonCard,
  },
  data() {
    return {
      alianza: null,
      rol: JSON.parse(localStorage.getItem("roles"))[0]?.rol || "",
      alianzas: [],
      modo: "rango",
      dates: [],
      polizas: [],
      reportDownload: [],
      statusMap: {
        0: "Nueva",
        1: "Activa",
        2: "Activa",
        3: "Activa",
        4: "Inactiva",
        5: "Inactiva",
        6: "Cancelada",
        7: "Duplicada",
        8: "Reactivacion",
      },
      columns: [
        { text: "ID Póliza", value: "poliza" },
        { text: "Status", value: "status" },
        { text: "Inicio Vigencia", value: "inicio" },
        { text: "Fin Vigencia", value: "fin" },
        { text: "Nombre", value: "nombre" },
        { text: "Apellido Paterno", value: "apellidoPaterno" },
        { text: "Apellido Materno", value: "apellidoMaterno" },
      ],
    };
  },
  computed: {
    puedeEjecutar() {
      // Restricción de fecha deshabilitada temporalmente.
      return (
        this.alianza &&
        (this.modo === "general" ||
          (this.modo === "rango" && this.dates.length === 2))
      );
    },
  },
  methods: {
    validarFecha(fecha) {
      const fechaLimite = moment().subtract(2, "months").startOf("day");
      return moment(fecha).isSameOrAfter(fechaLimite);
    },
    async obtenerAlianzas() {
      try {
        this.alianzas = (await getAlianzas()) || [];
      } catch (err) {
        this.alianzas = [];
        console.error("Error al obtener alianzas:", err);
      }
    },
    consultar() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      const body = {
        alianzaId: String(this.alianza),
       };

      let endpoint = "/v1/reportes/emisiones-alianzas";

      if (this.modo === "rango" && this.dates.length === 2) {
        const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
        const fin = moment
          .utc(this.dates[1])
          .add(24, "hours")
          .subtract(1, "seconds")
          .format("YYYY-MM-DD HH:mm:ss");

        body.fechaInicio = inicio;
        body.fechaFin = fin;
       }

      mainAxios.post(endpoint, body, config).then((res) => {
        this.polizas = [];
        this.reportDownload = [];

        res.data.forEach((el) => {
          const registro = {
            poliza: el.poliza,
            status: el.statusEtiqueta || "Desconocido",
            inicio: el.inicio,
            fin: el.fin,
            nombre: el.nombre,
            apellidoPaterno: el.apellidoPaterno,
            apellidoMaterno: el.apellidoMaterno,
          };
          this.polizas.push(registro);
          this.reportDownload.push(registro);
        });
      });
    },
    descargarCSV(reporteEci = false) {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
        responseType: "blob",
      };

      let body = {
        alianzaId: this.alianza,
        reporteEci: reporteEci
      };

      if (this.modo === "rango" && this.dates.length === 2) {
        const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
        const fin = moment
          .utc(this.dates[1])
          .add(24, "hours")
          .subtract(1, "seconds")
          .format("YYYY-MM-DD HH:mm:ss");

        body.fechaInicio = inicio;
        body.fechaFin = fin;
      }

      mainAxios.post("/v1/reportes/emisiones-alianzas/file", body, config).then((res) => {
        const blob = new Blob([res.data], { type: "application/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte_Emisiones_Alianzas.csv");
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  mounted() {
    this.obtenerAlianzas();
  },
};
</script>
